export default function TestimonialSection() {
  return (
    <section className="px-6 md:px-10 py-12 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto relative">
        <div className="bg-foreground-950 rounded-[2.5rem] overflow-hidden flex flex-col md:flex-row relative">
          <div className="md:w-2/5 relative -mt-8 md:-mt-0 md:-ml-8 md:my-8 flex justify-center md:justify-start">
            <div className="w-56 h-72 md:w-64 md:h-80 rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20off%20white%20leather%20sneakers%20with%20subtle%20grey%20suede%20accents%20product%20photography%20on%20warm%20taupe%20gradient%20backdrop%20with%20soft%20studio%20rim%20lighting%20creating%20elegant%20contour%20highlights%2C%20luxury%20footwear%20closeup%2C%20refined%20minimalist%20aesthetic%2C%20high%20detail%20craftsmanship%20visible&width=500&height=650&seq=testimonial-v2-501&orientation=portrait"
                alt="Produto CSSBuy Spreadsheet"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="md:w-3/5 p-8 md:p-12 flex flex-col justify-center">
            <span className="text-accent-300 text-7xl md:text-8xl font-heading leading-none mb-2">&ldquo;</span>
            <p className="text-white/90 text-base md:text-lg leading-relaxed">
              O CSSBuy Spreadsheet mudou completamente a forma como encontro produtos da China. 
              As planilhas s&atilde;o organizadas, sempre atualizadas e os links diretos economizam 
              horas de pesquisa. Recomendo para todo mundo que quer comprar streetwear de qualidade 
              com seguran&ccedil;a.
            </p>
            <div className="mt-6">
              <p className="text-white text-sm font-semibold">Comprador Verificado</p>
              <p className="text-white/50 text-xs mt-0.5">Comunidade CSSBuy Spreadsheet</p>
            </div>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-100/20 text-primary-300 border border-primary-300/30 hover:bg-primary-100/30 transition-all text-sm font-medium cursor-pointer whitespace-nowrap self-start"
            >
              Ver Produtos
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}